/**
 * 对对象数组按某属性进行排序 array.sort(getSortFun('desc', 'phone'));
 * @param order
 * @param sortBy
 * @returns {Function}
 */
export function getSortFun(order, sortBy) {
    var ordAlpah = (order == 'asc') ? '>' : '<';
    var sortFun = new Function('a', 'b', 'return a.' + sortBy + ordAlpah + 'b.' + sortBy + '?1:-1');
    return sortFun;
}